import React, { createContext, useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n'; // Make sure you import i18n if needed for event listeners

const SEOContext = createContext();

export const SEOProvider = ({ children }) => {
  const { t } = useTranslation();
  const [seoTags, setSeoTags] = useState({
    title: '',
    description: '',
    keywords: '',
  });

  useEffect(() => {
    // This function updates the SEO tags dynamically based on the current language and route
    const updateSeoTags = (newSeoTags) => {
      document.title = t(newSeoTags.title);
      const descriptionMetaTag = document.querySelector('meta[name="description"]');
      if (descriptionMetaTag) {
        descriptionMetaTag.setAttribute('content', t(newSeoTags.description));
      } else {
        const newDescriptionMetaTag = document.createElement('meta');
        newDescriptionMetaTag.setAttribute('name', 'description');
        newDescriptionMetaTag.setAttribute('content', t(newSeoTags.description));
        document.head.appendChild(newDescriptionMetaTag);
      }

      const keywordsMetaTag = document.querySelector('meta[name="keywords"]');
      if (keywordsMetaTag) {
        keywordsMetaTag.setAttribute('content', t(newSeoTags.keywords));
      } else {
        const newKeywordsMetaTag = document.createElement('meta');
        newKeywordsMetaTag.setAttribute('name', 'keywords');
        newKeywordsMetaTag.setAttribute('content', t(newSeoTags.keywords));
        document.head.appendChild(newKeywordsMetaTag);
      }

      setSeoTags(newSeoTags);
    };

    // Watch for language change
    const handleLanguageChange = () => {
      updateSeoTags(seoTags); // Update SEO tags when the language changes
    };

    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      // Cleanup listener when component is unmounted
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [t, seoTags]);

  return (
    <SEOContext.Provider value={{ seoTags, setSeoTags }}>
      {children}
    </SEOContext.Provider>
  );
};

export const useSEO = () => useContext(SEOContext);
